import { Injectable }     from '@angular/core';
import { Router }         from '@angular/router';
import { NetworkService } from './network.service';
import { UserService }    from './user.service';
import { DataService }    from './data.service';
import { EventsService }  from './events.service';
import {
  AUTH_TOKEN,
  EXPIRED_AUTH_TOKEN
}                         from '../../app.constants';
import { isDef }          from '../../utils';

@Injectable()
export class AuthenticationService {
  hasSession: boolean = false;

  constructor(
    private router: Router,
    private network: NetworkService,
    private userService: UserService,
    private dataService: DataService,
    private eventBus: EventsService
  ) {}

  activate () {
    this.checkUserSession();
    this.eventBus
      .on(EXPIRED_AUTH_TOKEN)
      .subscribe(() => {
        this.dataService.removeItem(AUTH_TOKEN);
        this.removeSession();
        setTimeout(() => {
            this.router.navigate([{ outlets: { popup: 'login' }}]);
        }, 0)
      });
  }

  checkUserSession () {
    const authToken = this.dataService.getItem(AUTH_TOKEN);
    if (isDef(authToken)) {
      this.startSession(authToken);
      this.userService.initUser();
    }
  }

  startSession (authToken: string) {
    this.hasSession = true;
    this.network.initSession(authToken);
  }

  removeSession () {
    this.hasSession = false;
    this.network.removeSession();
    this.router.navigateByUrl('/');
  }

  logOut () {
    this.network
      .logOut()
      .then(() => {
        this.dataService.removeItem(AUTH_TOKEN);
        this.removeSession();
      })
      .catch(err => {
        console.log(err);
      })
  }

  logIn (authData) {
    return this.network
      .logIn(authData)
      .then(response => {
        const authToken = response.token;
        this.startSession(authToken);
        this.dataService.setItem(AUTH_TOKEN, authToken);
        this.userService.initUser();
        return Promise.resolve(true);
      })
  }

  signUp (authData): Promise<Object> {
    return this.network.signUpUser(authData);
  }

  isAuthenticated () {
    return this.hasSession;
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/authentication.service.ts